import {
    ModalBody,
    VStack,
} from '@chakra-ui/react';
import { AccessIssuesWizardHeader } from '../components/wizard-header';
import { AccessIssuesWizardResolutionRenderer } from '../components/resolution-renderer';
import { AccessIssuesWizardProblemSetHeader } from '../components/problem-set-header';
import { AccessIssuesWizardTenantDetails } from '../components/tenant-details';
import { useIsInResolveMode } from '../hooks';

function AccessIssuesWizardResolveScreen() {
    const isInResolveMode = useIsInResolveMode();

    if (!isInResolveMode) return null;

    return (
        <ModalBody as={VStack} py={6} alignItems="stretch" gap={8}>
            <AccessIssuesWizardHeader showLockIcon />
            <AccessIssuesWizardProblemSetHeader />
            <VStack alignItems="stretch" gap={3}>
                <AccessIssuesWizardResolutionRenderer />
                <AccessIssuesWizardTenantDetails />
            </VStack>
        </ModalBody>
    );
}

export { AccessIssuesWizardResolveScreen };
